module.exports = __webpack_public_path__ + "img/4_83.151a23ca.png";